import { useContext } from 'react'
import { ConfirmationModalContext } from 'components/ConfirmationModal/ConfirmationModalProvider'

export const useConfirm = () => {
    const { openDialog } = useContext(ConfirmationModalContext)

    const getConfirmation = ({ ...options }) =>
        new Promise(res => {
            openDialog({ actionCallback: res, ...options })
        })

    return { getConfirmation }
}
